import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getHighRiskSupplementsDetails } from '@api/highRiskSupplements';
import { IHighRiskSupplementDetailsResponseDTO } from '@interfaces/highRiskSupplements';

export const handleGetHighRiskSupplementDetails = createAsyncThunk<
  AxiosResponse<IHighRiskSupplementDetailsResponseDTO>,
  number
>('getHighRiskSupplementsDetails', getHighRiskSupplementsDetails);
